// src/components/CSVModal.js
import React, { useEffect, useState } from "react";
import BulkFlagAdd from "../CSVFunctions/BulkFlagAdd";
import BulkFlagClear from "../CSVFunctions/BulkFlagClear";
import DroneOwnerAssignment from "../CSVFunctions/DroneOwnerAssignment";
import ProjectAssignment from "../CSVFunctions/ProjectAssignment";
import { Dialog } from "../components/ui/Dialog";
import { EmptyState } from "../components/ui/EmptyState";

const CSVModal = ({ droneIds, action, closeModal }) => {
  // Fed by the tool in the body; each tool starts clean, so a switch clears it.
  const [dirty, setDirty] = useState(false);
  useEffect(() => {
    setDirty(false);
  }, [action]);

  const renderContent = () => {
    switch (action) {
      case "bulkFlagAdd":
        return <BulkFlagAdd droneIds={droneIds} closeModal={closeModal} onDirtyChange={setDirty} />;
      case "bulkFlagRemove":
        return <BulkFlagClear droneIds={droneIds} closeModal={closeModal} onDirtyChange={setDirty} />;
      case "ownerAssignment":
        return <DroneOwnerAssignment droneIds={droneIds} closeModal={closeModal} onDirtyChange={setDirty} />;
      case "projectAssignment":
        return <ProjectAssignment droneIds={droneIds} closeModal={closeModal} onDirtyChange={setDirty} />;
      default:
        return <EmptyState variant="area">No valid action selected.</EmptyState>;
    }
  };

  return (
    <Dialog open onClose={closeModal} dirty={dirty} size="xl" label="Bulk action on selected drones">
      {/* Each action brings its own header, body and footer, so they run edge to edge */}
      <div className="-m-5 overflow-hidden rounded-overlay">
        {renderContent()}
      </div>
    </Dialog>
  );
};

export default CSVModal;
